import { render, staticRenderFns } from "./NbBoxesList.vue?vue&type=template&id=809080b6&scoped=true&"
import script from "./NbBoxesList.vue?vue&type=script&lang=js&"
export * from "./NbBoxesList.vue?vue&type=script&lang=js&"
import style0 from "./NbBoxesList.vue?vue&type=style&index=0&id=809080b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809080b6",
  null
  
)

export default component.exports